/* eslint-disable no-unused-vars */
export enum NameSpace {
	process = 'process',
	booking = 'booking',
	user = 'user',
	api = 'booking/api',
	authorization = 'authorization/api',
}
